import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import styled from "styled-components";
import logo from "../images/clone.png";

const apiUrl = "https://maintenance.cscoreentities.devtest.gf.aws.scania.com/loadrunner";

// Styled components
const Root = styled.div`
  height: 100%;
  margin: 2.8rem 1.8rem 0 1rem;
  text-align: left;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const StyledTh = styled.th`
  background-color: #154360;
  color: white;
  padding: 10px;
  text-align: left;
`;

const StyledTd = styled.td`
  padding: 10px;
  text-align: left;
`;

const TableRow = styled.tr`
  background-color: ${({ index }) => (index % 2 === 0 ? "#ffffff" : "#f5f5f5")};
`;

function Dashboard() {
  const storedJwt = localStorage.getItem("token");
  const [jwt] = useState(storedJwt || null);
  const [testResult, setTestResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getResultsfromS3();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getResultsfromS3 = async () => {
    try {
      setIsLoading(true);
      const options = {
        headers: {
          "Content-Type": "application/json",
          "X-Client": "ce/pulse-web-console",
          "Access-Control-Allow-Origin": "*",
          Authorization: jwt,
        },
      };

      const { data } = await axios.post(
        `${apiUrl}/jwt/api/v1/GetAllTestIdsFromDb`,
        {
          TEST_ID: "taurus_execution",
          S3_BUCKET: "ankur-test-taurus-docker",
          PREFIX: "ce",
          TEST_VAR: "testing from web-console",
          UUID: "4d93c88e-c1ee-46d1-81c6-e86ccc22cedd",
        },
        options
      );
      setTestResult(data);
      //console.log(data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <ScaleLoader height="30px" width="10px" color="#4287f5" />
        </div>
      ) : (
        <div style={{ height: "38px", width: "100%", clear: "both" }}></div>
      )}
      <Root>
        <StyledTable>
          <thead>
            <tr>
              <StyledTh width="350px">TestId</StyledTh>
              <StyledTh width="50px">Duration</StyledTh>
              <StyledTh width="50px">Status</StyledTh>
              <StyledTh width="250px">TimeCreated</StyledTh>
              <StyledTh width="115px">Method</StyledTh>
              <StyledTh width="250px">Test Url</StyledTh>
              <StyledTh colSpan={2}>Actions</StyledTh>
            </tr>
          </thead>
          <tbody>
            {testResult.map((row, index) => (
              <TableRow key={row.uuid} index={index}>
                <StyledTd>{row.uuid}</StyledTd>
                <StyledTd>{row.holdFor}</StyledTd>
                <StyledTd>{row.status}</StyledTd>
                <StyledTd>{row.dateInitiated}</StyledTd>
                <StyledTd>{row.httpMethod}</StyledTd>
                <StyledTd>{row.uri}</StyledTd>
                <StyledTd>
                  <Link
                    to={{
                      pathname: `/TestDetails/`,
                      search: `?testUUId=${row.uuid}`,
                      state: jwt,
                    }}
                  >
                    TestDetails
                  </Link>
                </StyledTd>
                <StyledTd>
                  <Link
                    to={{
                      pathname: `/CreateTest/`,
                      search: `?testUUId=${row.uuid}`,
                      state: jwt,
                    }}
                  >
                    <img src={logo} alt="Clone Test" title="Clone Test" />
                  </Link>
                </StyledTd>
              </TableRow>
            ))}
          </tbody>
        </StyledTable>
      </Root>
    </>
  );
}

export default Dashboard;
